import React from 'react';
import Image from 'next/image';
import { Button } from '@mui/material';
import {
  LangSelector as KitLangSelector,
  LangSelectorProps
} from '@ianesthesie-kit/core';
import {
  AvailableLocale,
  availableLocales,
  languageMap
} from '@ianesthesie-kit/config';
import en from './us.svg';
import fr from './fr.svg';
import es from './es.svg';
import { useChangeLanguageMutation } from '@/modules/userConfig';

type Locales = AvailableLocale;

const flagMap: { [key in Locales]: string } = {
  en,
  fr,
  es
};

const LangButton: LangSelectorProps['buttonComponent'] = ({
  locale,
  ...props
}) => (
  <Button
    {...props}
    color="inherit"
    variant="text"
    aria-label="language select"
    startIcon={
      <Image
        src={flagMap[locale as Locales]}
        alt={locale ?? ''}
        width={32}
        height={32}
        style={{ objectFit: 'contain' }}
      />
    }
  >
    {locale?.toUpperCase()}
  </Button>
);

export const LangSelector = () => {
  const [changeUserConfigLanguage] = useChangeLanguageMutation();

  return (
    <KitLangSelector
      locales={availableLocales}
      buttonComponent={LangButton}
      onLocaleChange={(locale) => {
        changeUserConfigLanguage(languageMap[locale]);
      }}
    />
  );
};
